export default __webpack_public_path__ + "static/media/step-middle.1f72b0f6.png";